<template>
  <div>
    <div
      :class="[backgroundColor, 'd-flex justify-start rounded overflow-hidden']"
    >
      <div :style="`width: ${barWidth}%`">
        <div :class="['px-2 py-1 d-flex', barColor]"></div>
      </div>
    </div>

    <div class="label text-caption d-flex" small :color="labelColor">
      <span>{{ percentage | percentage }} {{ percentageLabel }}</span>
      <v-spacer></v-spacer>
      <span>{{ value | number }}/{{ total | number }}</span>
    </div>
  </div>
</template>

<style scoped>
.label {
  height: auto;
}
</style>

<script>
import numeral from "numeral";

export default {
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    }
  },
  props: {
    backgroundColor: String,
    labelColor: String,
    valueLabel: String,
    value: Number,
    totalLabel: String,
    total: Number,
    percentageLabel: String
  },
  computed: {
    percentage() {
      return this.value / this.total;
    },
    barWidth() {
      return this.percentage * 100;
    },
    barColor() {
      if (this.percentage == 1) return "threshold-colors-1";
      if (this.percentage >= 0.75) return "threshold-colors-2";
      if (this.percentage >= 0.5) return "threshold-colors-3";
      if (this.percentage >= 0.35) return "threshold-colors-4";
      else return "threshold-colors-5";
    }
  }
};
</script>
